import React, { useEffect, useRef, useState } from 'react'
import { GoArrowDown } from "react-icons/go";
import { FaLinkedin } from "react-icons/fa6";
import Navbar from './Navbar';
import { Link } from 'react-router-dom';

const PARTICLE_COUNT = 80;
const INFRASTRUCTURE_STATS = [
    { label: 'Signals Evaluated', value: '2.3M+' },
    { label: 'Historical Data Points', value: '15B+' },
    { label: 'Strategies Tested', value: '1,200+' },
    { label: 'Markets Modeled', value: '40+' },
];

const ROTATING_WORDS = [
    'signal discovery',
    'alpha generation',
    'market structure',
];

const Hero = () => {
    const canvasRef = useRef(null);
    const particlesRef = useRef([]);
    const animationFrameRef = useRef(null);
    const [systemTime, setSystemTime] = useState('');
    const [activeWordIndex, setActiveWordIndex] = useState(0);
    const [isWordVisible, setIsWordVisible] = useState(true);
    const wordTimeoutRef = useRef(null);

    useEffect(() => {
        const canvas = canvasRef.current;
        if (!canvas) {
            return undefined;
        }

        const context = canvas.getContext('2d');
        let width = 0;
        let height = 0;

        const resetParticle = (particle, randomizePosition = false) => {
            particle.x = randomizePosition ? Math.random() * width : particle.x;
            particle.y = randomizePosition ? Math.random() * height : particle.y;
            particle.vx = (Math.random() - 0.5) * 0.08;
            particle.vy = (Math.random() - 0.5) * 0.08;
            particle.opacity = 0.12 + Math.random() * 0.18;
            particle.radius = 0.6 + Math.random() * 1.4;
        };

        const setupCanvas = () => {
            width = canvas.offsetWidth;
            height = canvas.offsetHeight;
            const pixelRatio = window.devicePixelRatio || 1;
            canvas.width = width * pixelRatio;
            canvas.height = height * pixelRatio;
            context.setTransform(pixelRatio, 0, 0, pixelRatio, 0, 0);

            particlesRef.current = Array.from({ length: PARTICLE_COUNT }, () => {
                const particle = {};
                resetParticle(particle, true);
                return particle;
            });
        };

        const drawLines = () => {
            for (let i = 0; i < particlesRef.current.length; i += 1) {
                const source = particlesRef.current[i];
                for (let j = i + 1; j < particlesRef.current.length; j += 1) {
                    const target = particlesRef.current[j];
                    const dx = source.x - target.x;
                    const dy = source.y - target.y;
                    const distance = Math.sqrt(dx * dx + dy * dy);

                    if (distance < 120) {
                        const lineOpacity = (1 - distance / 120) * 0.1;
                        context.strokeStyle = `rgba(180, 186, 205, ${lineOpacity})`;
                        context.lineWidth = 0.4;
                        context.beginPath();
                        context.moveTo(source.x, source.y);
                        context.lineTo(target.x, target.y);
                        context.stroke();
                    }
                }
            }
        };

        const render = () => {
            context.clearRect(0, 0, width, height);

            particlesRef.current.forEach((particle) => {
                particle.x += particle.vx;
                particle.y += particle.vy;

                if (particle.x < -10 || particle.x > width + 10 || particle.y < -10 || particle.y > height + 10) {
                    resetParticle(particle, true);
                }

                context.fillStyle = `rgba(211, 216, 230, ${particle.opacity})`;
                context.beginPath();
                context.arc(particle.x, particle.y, particle.radius, 0, Math.PI * 2);
                context.fill();
            });

            drawLines();
            animationFrameRef.current = window.requestAnimationFrame(render);
        };

        setupCanvas();
        render();

        window.addEventListener('resize', setupCanvas);

        return () => {
            window.removeEventListener('resize', setupCanvas);
            if (animationFrameRef.current) {
                window.cancelAnimationFrame(animationFrameRef.current);
            }
        };
    }, []);

    useEffect(() => {
        const updateTimestamp = () => {
            const now = new Date();
            const formatted = now.toISOString().replace('T', ' ').slice(0, 16);
            setSystemTime(`${formatted} UTC`);
        };

        updateTimestamp();
        const timestampInterval = window.setInterval(updateTimestamp, 60000);

        return () => window.clearInterval(timestampInterval);
    }, []);

    useEffect(() => {
        const intervalId = window.setInterval(() => {
            setIsWordVisible(false);

            wordTimeoutRef.current = window.setTimeout(() => {
                setActiveWordIndex((currentIndex) => (currentIndex + 1) % ROTATING_WORDS.length);
                setIsWordVisible(true);
            }, 350);
        }, 2500);

        return () => {
            window.clearInterval(intervalId);
            if (wordTimeoutRef.current) {
                window.clearTimeout(wordTimeoutRef.current);
            }
        };
    }, []);

    // Store scroll position in state
    const scrollToSection = (id) => {
        const element = document.getElementById(id);
        if (element) {
            element.scrollIntoView({ behavior: 'smooth' });

        }
    };
    return (
        <div id='home' className='hero'>
            <div className='hero-bg' aria-hidden='true' style={{ backgroundImage: "url('/herobg.jpg')", backgroundPosition: 'center', backgroundSize: 'cover', backgroundRepeat: 'no-repeat' }} />
            <div className="flex justify-center min-h-[100svh] h-auto lg:min-h-[800px] relative overflow-visible">
                <div className='flex flex-col justify-center items-start md:items-center z-10 bg-black bg-opacity-70 absolute inset-0 px-8 md:px-12 lg:px-16 min-h-[100dvh]'>
                    <canvas
                        ref={canvasRef}
                        className='absolute inset-0 h-full w-full pointer-events-none opacity-70'
                        aria-hidden='true'
                    />
                    {/* Hero */}
                    <Navbar />
                    {/* hero */}
                    <div className='hero-content h-full w-full flex max-w-[1100px]'>
                        <div>
                            <h1 className='text-[40px] md:text-[65px] lg:text-[72px] xl:text-[86px] domin font-semibold leading-tight capitalize text-white'><span className='q-letter'>Q</span>Lab</h1>
                            <div className='flex flex-col lg:flex-row justify h-fit gap-2 mt-8'>
                                <hr className='w-[3rem] block h-[1px] bg-primary-dark border-primary-dark items-center my-4 b ' />
                                <h1 className='text-[22px] md:text-[24px] metro leading-tight text-[#FFFFFFCC]'>
                                    Quantitative Research Laboratory<br />
                                    Developing systematic models for <br />
                                    <span
                                        className={`rotating-word${isWordVisible ? ' is-visible' : ''}`}
                                    >
                                        {ROTATING_WORDS[activeWordIndex]}
                                    </span><br />
                                    across global markets.
                                </h1>
                            </div>
                            <div className='system-status mt-6 text-[#FFFFFFB3]'>
                                <p className='uppercase tracking-[0.18em] text-[11px] text-[#8AF0A4]'>● Live · Research Systems Online</p>
                                <p className='text-[11px] text-[#FFFFFF99] mt-1'>Last Research Cycle: <span id='system-time'>{systemTime}</span></p>
                            </div>
                            <div className='infrastructure-panel mt-10'>
                                <p className='text-[11px] uppercase tracking-[0.2em] text-[#FFFFFF99]'>Research Infrastructure</p>
                                <div className='infrastructure-stats mt-4 grid grid-cols-2 gap-3'>
                                    {INFRASTRUCTURE_STATS.map((stat) => (
                                        <div key={stat.label} className='infrastructure-stat'>
                                            <p className='stat-value text-white metro-semi'>{stat.value}</p>
                                            <p className='stat-label text-[#FFFFFFB3]'>{stat.label}</p>
                                        </div>
                                    ))}
                                </div>
                            </div>
                        </div>


                    </div>
                    {/* heroo bottom  */}
                    <div className='w-full max-w-screen-3xl flex justify-between pb-8 md:pb-20'>
                        <div className='flex gap-4 items-center text-white list-none mt-5 pb-8 md:mt-0 md:pb-0' >
                            <li className='mr-8 '>Follow Us</li>
                            <Link target="_blank" rel="noopener noreferrer" to='https://www.linkedin.com/company/qlabs-work/?viewAsMember=true'><li><span className='hidden sm:block'>LinkedIn</span> <FaLinkedin className='block sm:hidden text-white' /></li></Link>
                        </div>
                        <div className='scroll-indicator flex gap-4 items-center cursor-pointer' onClick={() => scrollToSection('research')}>
                            <p className='uppercase text-white text-[11px] hidden lg:block'>
                                Scroll Down
                                <span className='arrow' aria-hidden='true' />
                            </p>
                            <span className='w-12 h-12 flex items-center justify-center bg-white rounded-full'>
                                <GoArrowDown />
                            </span>
                        </div>
                    </div>

                    {/* hero side links */}
                    <div className='hidden lg:flex flex-col justify-center absolute inset-y-0 z-10 right-0'>
                        <div onClick={() => scrollToSection('research')} className='bg-black cursor-pointer bg-opacity-20 py-6 hover:bg-opacity-50 transition-all duration-500 pl-6 pr-40'>
                            <h1 className='flex flex-col text-white leading-3' >
                                <span className='flex items-center gap-4 text-[13px] tracking-[2px]'>
                                    <hr className='w-1.5 h-[7px] border-primary-dark rounded-full bg-primary-dark' />
                                    RESEARCH</span> <br />
                                <span className='capitalize text-[15px] ml-5 text-[#FFFFFF80]'>Research philosophy</span>
                            </h1>
                        </div>
                        <div onClick={() => scrollToSection('engines')} className='bg-black cursor-pointer bg-opacity-20 py-6 hover:bg-opacity-50 transition-all duration-500 pl-6 pr-40'>
                            <h1 className='flex flex-col text-white leading-3' >
                                <span className='flex items-center gap-4 text-[13px] tracking-[2px]'>
                                    <hr className='w-1.5 h-[7px] border-primary-dark rounded-full bg-primary-dark' />
                                    RESEARCH INFRASTRUCTURE</span> <br />
                                <span className='capitalize text-[15px] ml-5 text-[#FFFFFF80]'>Research framework</span>
                            </h1>
                        </div>
                        <div onClick={() => scrollToSection('lab')} className='bg-black cursor-pointer bg-opacity-20 py-6 hover:bg-opacity-50 transition-all duration-500 pl-6 pr-40'>
                            <h1 className='flex flex-col text-white leading-3' >
                                <span className='flex items-center gap-4 text-[13px] tracking-[2px]'>
                                    <hr className='w-1.5 h-[7px] border-primary-dark rounded-full bg-primary-dark' />
                                    LAB</span> <br />
                                <span className='capitalize text-[15px] ml-5 text-[#FFFFFF80]'>Inside the lab</span>
                            </h1>
                        </div>
                        <div onClick={() => scrollToSection('contact')} className='bg-black cursor-pointer bg-opacity-20 py-6 hover:bg-opacity-50 transition-all duration-500 pl-6 pr-40'>
                            <h1 className='flex flex-col text-white leading-3' >
                                <span className='flex items-center gap-4 text-[13px] tracking-[2px]'>
                                    <hr className='w-1.5 h-[7px] border-primary-dark rounded-full bg-primary-dark' />
                                    CONTACT</span> <br />
                                <span className='capitalize text-[15px] ml-5 text-[#FFFFFF80]'>Partnerships</span>
                            </h1>
                        </div>
                    </div>
                </div>
            </div>

        </div>
    )
}

export default Hero
